/* eslint-disable @typescript-eslint/no-explicit-any */
import { Delete, Get, Patch, Post } from "./apiHelper";
import { ApiResponse } from "../interfaces/Api";
import { IShiftAssignment } from "../interfaces/ShiftAssignmentInterface";

const shiftAssignmentRoot = "/api/shiftAssignments";

// get shift assignments
export async function getShiftAssignments(params: {
  resourceCentreId: number;
  fromDate?: string;
  toDate?: string;
}): Promise<ApiResponse<Array<IShiftAssignment>>> {
  const searchParams = new URLSearchParams();
  searchParams.append("resourceCentreId", params.resourceCentreId.toString());

  if (params?.fromDate) {
    searchParams.append("fromDate", params.fromDate);
  }
  if (params?.toDate) {
    searchParams.append("toDate", params.toDate);
  }

  const queryString = searchParams.toString();
  const url = queryString ? `${shiftAssignmentRoot}?${queryString}` : shiftAssignmentRoot;

  const response = await Get(url, true);
  return response.data as ApiResponse<Array<IShiftAssignment>>;
}

// post shift assignment
export async function postShiftAssignment(
  data: Partial<IShiftAssignment>
): Promise<ApiResponse<IShiftAssignment>> {
  const response = await Post(`${shiftAssignmentRoot}`, data as any, true);
  return response.data as ApiResponse<IShiftAssignment>;
}

// patch shift assignment
export async function patchShiftAssignment({
  id,
  data
}: {
  id: number | string;
  data: Partial<IShiftAssignment>;
}): Promise<ApiResponse<IShiftAssignment>> {
  const response = await Patch(`${shiftAssignmentRoot}/${id}`, data as any, true);
  return response.data as ApiResponse<IShiftAssignment>;
}

// delete shift assignment
export async function deleteShiftAssignment(id: number | string): Promise<ApiResponse<null>> {
  const response = await Delete(`${shiftAssignmentRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
}
